<template>
  <div class="w-100">
    <template v-for="tag in tags">
      <div
        :key="tag.index"
        class="d-flex align-items-center position-relative"
        :class="formInput ? 'mt-1' : 'mb-1'"
      >
        <validation-provider
          #default="{ errors }"
          :vid="`key${tag.index}`"
          name="Key"
          rules="required"
          class="w-50"
          :class="{ 'icon-left': !fullWidth }"
        >
          <b-input
            :id="`key${tag.index}`"
            v-model="tag.key"
            :state="errors.length > 0 ? false : null"
            placeholder="Key"
            class="mb-0"
          />
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          :vid="`value${tag.index}`"
          name="Value"
          rules="required"
          :class="fullWidth ? 'custom-width' : 'w-50'"
        >
          <b-input
            :id="`value${tag.index}`"
            v-model="tag.value"
            :state="errors.length > 0 ? false : null"
            placeholder="Value"
            class="mb-0 mr-0"
          />
        </validation-provider>
        <a
          class="right-icon"
          :class="{ absolute: formInput }"
          @click="$emit('remove-field', tag.index)"
        >
          <GjIcon name="Delete" />
        </a>
      </div>
    </template>
    <div
      class="px-1 px-md-2"
      :class="{ 'mt-1': tags.length > 0 || formInput }"
    >
      <a
        class="text-primary text-medium"
        @click="onAddField"
      >
        + Add {{ tagName }}
      </a>
    </div>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'Tags',
  components: { ValidationProvider },
  props: {
    tags: {
      type: Array,
      required: true,
    },
    formInput: {
      type: Boolean,
      default: false,
    },
    tagName: {
      type: String,
      default: 'tag',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    lastIndex() {
      return this.tags.length ? this.tags[this.tags.length - 1].index : 0
    },
  },
  methods: {
    onAddField() {
      this.tags.push({
        index: this.lastIndex + 1,
        key: '',
        value: '',
      })
    },
    onRemoveField(index) {
      this.tags = this.tags.filter(obj => obj.index !== index)
    },
  },
}
</script>
<style lang="scss" scoped>
.right-icon {
  margin-left: 10px;
  &.absolute {
    position: absolute;
    left: 100%;
  }
}
.custom-width {
  width: calc(50% - 2rem);
  margin-left: 2rem;
  @media (max-width: 767.8px) {
    width: calc(50% - 1rem);
    margin-left: 1rem;
  }
}
</style>
